import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'
import styled from 'styled-components'

export interface StatusAndSubmitDocProps {
  className?: string
  formUrl: string
  isReceived: boolean
  title: string
}

const StyledSection = styled.section`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const StyledParagraph = styled.p`
  align-self: center;
  margin-bottom: 0;
  margin-right: 20px;
`

const StyledButton = styled(SecondaryButton)`
  white-space: nowrap;
`

const StatusAndSubmitDoc: FC<StatusAndSubmitDocProps> = ({
  className,
  formUrl,
  isReceived,
  title,
}) => {
  return (
    <StyledSection className={className}>
      <StyledParagraph>
        Your {title} <strong>{isReceived ? 'is' : 'is not'}</strong> on file with us.
      </StyledParagraph>
      <StyledButton as="a" href={formUrl} target="_blank">
        {isReceived ? 'Resubmit' : 'Submit'} your {title}
      </StyledButton>
    </StyledSection>
  )
}

export default StatusAndSubmitDoc
